export default "__VITE_ASSET__9edbb03d__"